module.exports = __webpack_public_path__ + "img/stepMeeting.f2946628.png";